import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs,  } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
@Injectable({
    providedIn: 'root'
  })
export class EligibilityReportService extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService) {
        super();
    }
    public ouputValues(state): void {
        this.getEligibility(state).subscribe(x => super.next(x));
    }
    getEligibility(state): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/ClaimProcess/GetEligibilitySummaryList", state)
            .pipe(map(
                (response: any) => (<any>{


                    result: response['edi271clientlist'],
                    count: response['totalCount']
                }))).pipe(map((e: any) => {
                    e.result.forEach(element => {

                    })
                    return e;
                })

                )
    }
}
